export default {
  'label/new_appointment': 'Nova Consulta',
  'action/refresh': 'Atualizar Agenda',
  'action/all_rooms': 'Todas as Salas',
  'label/all_subfilters': 'Todos',
  'label/calendar_day': 'Dia',
  'label/calendar_week': 'Semana',
  'label/calendar_today': 'Hoje',
  'label/blocked_time': 'Horário Bloqueado',
  'label/hour': 'Hora',
  'action/select_month': 'Selecione o mês',
  'label/duration': 'Duração',
  'action/hide': 'Remover da Agenda',
  'action/delete_only': 'Deletar somente este evento',
  'action/delete_future': 'Deletar todos os eventos futuros',
  'label/date/tomorrow': 'Amanhã',
  'label/date/yesterday': 'Ontem',
  'label/title': 'Título',
  'label/whatsApp': 'Confirmar via WhatsApp',
  'label/online/menu_on': 'Consulta online',
  'label/online/menu_off': 'Consulta presencial',
  'label/online/title': 'Consulta online',
  'label/online/toggle': 'Consulta online',
  'label/online/link': 'Link da chamada',
  'label/online/own_link': 'O paciente recebe este link em vez do link fixo da sala.',
  'label/online/uses_doctor_link': 'Em branco, vale o link fixo da sala do profissional:',
  'label/online/no_link': 'Cole o link da chamada (Google Meet, Zoom, WhatsApp...) ou cadastre o link fixo da sala em Ajustes › Doutores.',
  'label/online/google_meet': 'Ao salvar, o Doutore cria um link próprio do Google Meet para esta consulta.',
  'label/online/google_meet_placeholder': 'Link do Google Meet criado ao salvar',
  'label/online/google_title': 'Link do Google Meet automático',
  'label/online/google_connect': 'Conecte o seu Google Agenda e não precisa mais colar link: cada consulta online ganha um link próprio do Google Meet ao salvar, e suas consultas aparecem no Google Agenda, no celular e no computador.',
  'label/online/google_reconnect': 'A conexão com o Google Agenda caiu: o acesso foi removido ou a agenda “Doutore” foi apagada. Conecte de novo para o link do Google Meet voltar a sair sozinho.',
  'label/online/google_opened': 'Entre com sua conta Google na página que abriu e volte para cá: o link passa a ser criado ao salvar.',
  'label/online/google_doctor': 'Quando {{doctor}} conectar o Google Agenda na própria conta, em Ajustes › Google Agenda, cada consulta online ganha um link próprio do Google Meet ao salvar.',
  'label/online/google_doctor_unnamed': 'Quando o profissional conectar o Google Agenda na própria conta, em Ajustes › Google Agenda, cada consulta online ganha um link próprio do Google Meet ao salvar.',
  'label/online/google_until_then': 'Até lá, cole o link aqui.',
  'action/online/connect_google': 'Conectar Google Agenda',
  'label/online/patient_gets_link': 'Na confirmação pelo WhatsApp, o paciente vê "consulta online" e o link da chamada no lugar do endereço.',
  'action/online/join': 'Entrar na chamada',
  'action/online/join_short': 'Chamada',
  'error/online/invalid_link': 'Link inválido. Cole o endereço completo, como https://meet.google.com/abc-defg-hij',
  'label/sendMessage': 'Enviar mensagem',
  'label/contracted_services': 'Serviços Contratados',
  'label/show_obs': 'Mostrar observações no prontuário',
  'label/status/scheduled': 'Consulta agendada',
  'label/status/sms_sent': 'SMS enviado',
  'label/status/sms_confirmed': 'Confirmada pelo paciente',
  'label/status/sms_canceled': 'Cancelada pelo paciente',
  'label/status/confirmed': 'Consulta confirmada',
  'label/status/patient_arrived': 'Paciente chegou',
  'label/status/patient_attended': 'Paciente atendido',
  'label/status/patient_missed': 'Paciente faltou',
  'label/status/patient_canceled': 'Paciente cancelou',
  'label/status/canceled_by_doctor': 'Consultório cancelou',
  // An appointment's status in one word, on the agenda
  'label/badge/confirmed': 'Confirmada',
  'label/badge/arrived': 'Chegou',
  'label/badge/completed': 'Atendida',
  'label/badge/missed': 'Faltou',
  'label/badge/canceled': 'Cancelada',
  'label/badge/scheduled': 'Agendada',
  // The appointment form's rows: what each shows (the field's name while empty)
  'label/row/recurrence/none': 'Repetir consulta',
  'label/row/recurrence/none_block': 'Repetir horário',
  'label/row/recurrence/other': 'Recorrente',
  'label/row/recurrence/appointments': 'consultas',
  'label/row/recurrence/appointments_one': 'consulta',
  'label/row/recurrence/blocks': 'horários',
  'label/row/recurrence/blocks_one': 'horário',
  'label/row/status_at': 'DD/MM [às] HH:mm',
  'label/change_status': 'Alterar status',
  // The status screen: what happened to the appointment, and what can still happen
  'label/status/timeline': 'Histórico',
  'label/status/update': 'Atualizar status',
  'action/status/undo': 'Desfazer',
  'format/status_date': 'DD/MMM [às] HH:mm',
  'label/status/stays/missed': 'Estes entram no histórico, mas o status continua "Faltou".',
  'label/status/stays/canceled': 'Estes entram no histórico, mas o status continua "Cancelada".',
  'action/status/history': 'Histórico de alterações',
  'action/status/history_label': 'Histórico de alterações, abre no Painel de Controle',
  'label/services/empty_edit': 'Esta consulta não tem serviços',
  'label/services/empty_new': 'Nenhum serviço cadastrado',
  'label/services/empty_new_hint': 'Cadastre os serviços em Ajustes › Tabela de Serviços. Eles aparecem aqui para escolher na consulta e lançar no financeiro do paciente.',
  'label/services/empty_search': 'Nenhum serviço encontrado para esta busca',
  'label/services/recents': 'Mais Recentes',
  'label/services/private': 'Particular',
  'label/services/health_plan': 'Plano de Saúde',
  'label/services/loading': 'Carregando serviços',
  'action/services/add_services': 'Adicionar serviços',
  'label/patient_vip': 'Paciente com Gratuidade',
  'label/services/service_list': 'Lista de Serviços',
  'action/services/view_selected_services': 'Ver todos os serviços selecionados',
  'label/rooms/select_one_room': 'Selecione uma sala',
  'label/recurrency/recurrent_appointment': 'Agendamento recorrente',
  'label/recurrency/none': 'Não repete',
  'label/recurrency/weekly': 'Toda semana',
  'label/recurrency/weekly_hint': 'Em um ou mais dias da semana',
  'label/recurrency/biweekly': 'A cada 2 semanas',
  'label/recurrency/biweekly_hint': '{0} sim, {1} não',
  'label/recurrency/days': 'Dias da semana',
  'label/recurrency/short/monday': 'Seg',
  'label/recurrency/short/tuesday': 'Ter',
  'label/recurrency/short/wednesday': 'Qua',
  'label/recurrency/short/thursday': 'Qui',
  'label/recurrency/short/friday': 'Sex',
  'label/recurrency/short/saturday': 'Sáb',
  'label/recurrency/short/sunday': 'Dom',
  'label/recurrency/pick_a_day': 'Escolha pelo menos um dia da semana.',
  'label/recurrency/count': 'Número de consultas',
  'label/recurrency/count_blocked': 'Número de horários',
  'action/recurrency/fewer': 'Menos',
  'action/recurrency/more': 'Mais',
  'label/recurrency/summary': 'São {0} consultas, de {1} a {2}.',
  'label/recurrency/summary_blocked': 'São {0} horários bloqueados, de {1} a {2}.',
  'label/recurrency/starts_later': 'A série começa no primeiro dia marcado, não em {0}.',
  'label/recurrency/series': 'Faz parte de uma série de {0} consultas.',
  'label/recurrency/series_blocked': 'Faz parte de uma série de {0} horários bloqueados.',
  'label/recurrency/delete_all_future_events': 'Excluir esta e as próximas consultas',
  'label/recurrency/delete_all_future_blocked': 'Excluir este e os próximos horários',
  'label/doctor_select/title': 'Selecione um Profissional',
  'label/doctor_select/loading': 'Carregando doutores',
  'label/patient_select/add_patient': 'Cadastrar novo paciente',
  'label/patient_select/search_patient': 'Buscar paciente',
  'label/patient_select/search_all_patients': 'Todos os pacientes',
  'label/patient_select/reschedule_patients': 'Pacientes com etiqueta reagendar',
  'label/patient_select/loading': 'Carregando pacientes',
  'label/patient_select/suggested': 'Pacientes Sugeridos',
  'label/patient_select/incomplete_list': '* Essa lista de pacientes está incompleta - para encontrar outros pacientes, digite o nome em "Buscar paciente"',
  'label/patient_form/name': 'Nome',
  'label/patient_form/birthdate': 'Data de nascimento',
  'label/patient_form/cpf': 'CPF',
  'label/patient_form/legalId': 'Identidade',
  'label/patient_form/mobile_phone': 'Celular',
  'label/patient_form/email': 'E-mail',
  'label/patient_form/recommended_by': 'Indicação',
  'label/patient_form/profession': 'Profissão',
  'label/patient_form/placeOfBirth': 'Naturalidade',

  'label/patient_form/maritalStatusCode': 'Estado Civil',
  'label/patient_form/doctorId': 'Responsável',
  'label/patient_form/medic': 'Médico',
  'label/patient_form/mobilePhone': 'Celular',
  'label/patient_form/homePhone': 'Telefone Fixo',
  'label/patient_form/otherPhone': 'Telefone Adicional',
  'label/patient_form/father': 'Pai',
  'label/patient_form/mother': 'Mãe',
  'label/patient_form/guardianName': 'Responsável',
  'label/patient_form/guardianRelationship': 'Parentesco',
  'label/patient_form/insuranceCompany': 'Convênio',
  'label/patient_form/insurancePlan': 'Plano',
  'label/patient_form/insuranceNumber': 'Número da Carteira',
  'label/patient_form/insuranceExpirationDate': 'Data de Validade',

  'label/patient_form/insurance_plan': 'Plano de Saúde',
  'label/patient_form/title': 'Novo Paciente',
  'label/patient_info/title': 'Resumo do cadastro',
  'label/patient_info/responsible': 'Responsável',
  'label/patient_info/other_phone': 'Telefone Adicional',
  'label/patient_info/select_another': 'Selecionar outro paciente',
  'label/patient_info/missing': 'Falta no cadastro',
  'label/patient_info/address': 'Endereço',
  'action/patient_info/open_profile': 'Abrir cadastro',
  'label/patient_info/link_title': 'Cadastro feito pelo paciente',
  'label/patient_info/link_text': 'O próprio paciente pode preencher o cadastro pelo celular: nascimento, CPF, endereço e contato. O que ele salvar atualiza este cadastro.',
  'label/patient_info/link_step_open': 'Abra a página do link, no navegador.',
  'label/patient_info/link_step_send': 'Lá, gere o link e envie por WhatsApp ou copie.',
  'label/patient_info/link_step_expires': 'O link vale até o paciente salvar o cadastro.',
  'action/patient_info/open_link_page': 'Abrir página do link',
  'label/patient_info/link_after_save': 'Salve a consulta para abrir a página do link.',
  'label/appointment_with': 'Consulta com',
  'label/appointment_sms_canceled': 'Consulta cancelada pelo paciente',
  'label/appointment_patient_msg': 'Paciente deixou a Mensagem',

  'label/patient_form/patient_code': 'Código',

  'action/click_to_create_appointment_at': 'Clique para criar consulta ás',
  'action/click_to_create_appointment': 'Clique para criar uma consulta',
  'label/calendar_month': 'Mês',
  'label/no_appointments': 'Nenhuma consulta agendada',
  'label/agenda_load_failed': 'Não foi possível carregar a agenda. Toque em ↻ para tentar de novo.',
};
